import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "preferencesgeneral"
    }}>{`PreferencesGeneral`}</h1>
    <p>{`General preferences`}</p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`名称`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`类型`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`访问`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`最低版本`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`描述`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`autoUpdateOpenDocuments`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R W`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`24.0`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Determines whether to automatically re-read open file-based documents updated outside Photoshop. Cloud documents are not affected by this setting.`}{`'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`beepWhenDone`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R W`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`24.0`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`If true, alerts the user when a command completes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`colorPicker`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/uxp-photoshop-zh-cn/ps_reference/interfaces/colorpickerarg/"
            }}><em parentName="a">{`ColorPickerArg`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R W`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`24.0`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Changes color picker within the Photoshop. It uses object where `}{`\``}{`type`}{`\``}{` property is color picker type to use. If color picker type is `}{`\``}{`ColorPicker.PLUGIN`}{`\``}{` then also `}{`\``}{`pluginID`}{`\``}{` property must be provided and must contain internal ID of the plugin as a string.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`exportClipboard`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R W`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`24.0`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`If true, retains Adobe Photoshop contents on the clipboard after you exit the application.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`imageInterpolation`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/uxp-photoshop-zh-cn/ps_reference/modules/constants/#interpolationmethod"
            }}><em parentName="a">{`InterpolationMethod`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R W`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`24.0`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Method used when scaling or resizing images.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`typename`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`24.0`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The class name of the referenced object: `}<em parentName="td">{`"`}{`PreferencesGeneral`}{`"`}</em>{`.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      